module.exports = __webpack_public_path__ + "img/pack.2c3010d5.png";